import React, { useState } from 'react';
import './DepartmentPrompt.css';
import { useUser } from '../contexts/UserContext';
import { getDivisions } from '../utils/departments';

const DivisionPrompt: React.FC = () => {
  const { user, division, setDivision, divisionModalOpen, setDivisionModalOpen } = useUser();
  const [selected, setSelected] = useState(division || '');
  const divisions = getDivisions();

  if (!divisionModalOpen || !user) return null;

  const handleSave = () => {
    if (selected) setDivision(selected);
  };

  return (
    <div className="dept-prompt-overlay">
      <div className="dept-prompt-modal">
        <div className="dept-prompt-header">
          <h2>Select Your Division</h2>
          {division && (
            <button className="dept-prompt-close" onClick={() => setDivisionModalOpen(false)}>✕</button>
          )}
        </div>
        <p className="dept-prompt-desc">
          Your division helps route your initiative to the right approvers.
        </p>
        <div className="dept-prompt-list">
          {divisions.map((div) => (
            <button
              key={div}
              className={`dept-option ${selected === div ? 'selected' : ''}`}
              onClick={() => setSelected(div)}
            >
              {div}
            </button>
          ))}
        </div>
        <div className="dept-prompt-footer">
          <button
            className="dept-save-btn"
            disabled={!selected}
            onClick={handleSave}
          >
            Confirm Division
          </button>
        </div>
      </div>
    </div>
  );
};

export default DivisionPrompt;
